import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import ParentDashboard from "@/pages/ParentDashboard";
import TeacherDashboard from "@/pages/TeacherDashboard";
import SchoolAdminDashboard from "@/pages/SchoolAdminDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ReportCard from "@/pages/ReportCard";
import { AuthProvider, useAuth } from "@/lib/auth";

function Protected({ roles, children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/login" replace />;
  return children;
}

function RoleRoot() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "parent") return <Navigate to="/parent" replace />;
  if (user.role === "teacher") return <Navigate to="/teacher" replace />;
  if (user.role === "school_admin") return <Navigate to="/school-admin" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RoleRoot />} />
          <Route path="/login" element={<Login />} />
          <Route path="/parent" element={<Protected roles={["parent"]}><ParentDashboard /></Protected>} />
          <Route path="/parent/child/:studentId" element={<Protected roles={["parent"]}><ReportCard /></Protected>} />
          <Route path="/teacher" element={<Protected roles={["teacher"]}><TeacherDashboard /></Protected>} />
          <Route path="/teacher/student/:studentId" element={<Protected roles={["teacher"]}><ReportCard /></Protected>} />
          <Route path="/school-admin" element={<Protected roles={["school_admin"]}><SchoolAdminDashboard /></Protected>} />
          <Route path="/school-admin/student/:studentId" element={<Protected roles={["school_admin", "admin"]}><ReportCard /></Protected>} />
          <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}
